// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1gdvJ","column":"style_column__3K0K5","row":"style_row__bhV6x"};